import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ApiService } from 'app/shared/api.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-monitor-ads',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './monitor-ads.component.html',
  styleUrls: ['./monitor-ads.component.scss']
})
export class MonitorAdsComponent implements OnInit, OnDestroy {
  tenantCode: string = '';
  slug: string = '';
  adData: any = null;
  isLoading: boolean = true;
  error: boolean = false;

  currentIndex: number = 0;
  progress: number = 0;
  private intervalId: any;
  private progressIntervalId: any;

  constructor(
    private route: ActivatedRoute,
    private api: ApiService
  ) {}

  getMediaUrl(m: any): string {
    if (!m) return '';
    
    let url = m.original_url || m.file_url || m.url;
    
    // Fallback: Manually construct Spatie Media Library URL if original_url is missing from the API
    if (!url && m.id && m.file_name) {
       url = environment.baseurl_api + 'storage/' + m.id + '/' + m.file_name;
    }
    
    if (!url) return '';
    
    // Ensure relative URLs resolve correctly
    if (!url.startsWith('http') && !url.startsWith('/')) {
      url = '/' + url;
    }
    
    return url;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.tenantCode = params['tenantCode'];
      this.slug = params['slug'];
      if (this.tenantCode && this.slug) {
        this.loadAdData();
      }
    });
  }

  ngOnDestroy(): void {
    this.clearTimers();
  }

  async loadAdData() {
    this.isLoading = true;
    this.error = false;
    try {
      const tenant = this.tenantCode ? this.tenantCode.toLowerCase() : '';
      const res = await this.api.getPublic(`api/v1/public/media-display/${tenant}/${this.slug}`);
      if (res?.success && res?.data) {
        this.adData = res.data;
        console.log('Loaded Ad Data:', this.adData);
        this.startTimers();
      } else {
        this.error = true;
      }
    } catch (e) {
      console.error('Error loading ad', e);
      this.error = true;
    } finally {
      this.isLoading = false;
    }
  }

  startTimers() {
    this.clearTimers();
    this.progress = 0;
    
    if (this.adData?.media && this.adData.media.length > 1) {
      this.progressIntervalId = setInterval(() => {
        this.progress += 1;
      }, 30);

      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, 3000);
    }
  }

  clearTimers() {
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.progressIntervalId) clearInterval(this.progressIntervalId);
    this.progress = 0;
  }

  nextSlide() {
    if (this.adData?.media) {
      this.currentIndex = (this.currentIndex + 1) % this.adData.media.length;
      this.startTimers();
    }
  }

  prevSlide() {
    if (this.adData?.media) {
      this.currentIndex = (this.currentIndex - 1 + this.adData.media.length) % this.adData.media.length;
      this.startTimers();
    }
  }
}
